import Git from '../images/git.svg'
import CodePen from '../images/codepen.svg'
import LinkedIn from '../images/linkedin.svg'
import Instagram from '../images/instagram.svg'

const SocialData = [
  {
    icon: Git,
    link: `https://git.thewhitmans.cloud/kendall`,
    name: `Gitea`,
  },
  // {
  //   icon: CodePen,
  //   link: `https://codepen.io/KendallWhitman`,
  //   name: `CodePen`,
  // },
  {
    icon: LinkedIn,
    link: `https://www.linkedin.com/in/kendallwhitman`,
    name: `LinkedIn`,
  },
  // {
  //   icon: Instagram,
  //   link: `https://www.instagram.com/kendallawhitman/`,
  //   name: `Instagram`,
  // },
]

export default SocialData
